import PropTypes from 'prop-types';

import { cn } from '@/lib/utils';

import { ReactComponent as ShapeBgBig } from '@/svg/shape-bg/shape-bg-big.svg';
import { ReactComponent as ShapeBgMed } from '@/svg/shape-bg/shape-bg-medium.svg';

import { headingVariants } from '@/components/ui/heading';

const FormHeaderTitle = ({ variant, title, subtitle, className, titleClassName, subtitleClassName, ...props }) => {
	const shapeColor = `text-${variant}`;
	const shapeBgColor = `bg-${variant}`;

	return (
		<div className={cn('relative w-full overflow-hidden', className)}>
			{/* Note: for screen wider than 1440px */}
			<ShapeBgBig className={cn('min-w-full hidden 2xl:block', shapeColor)} />

			{/* Note: for screen width between 1440px and 1024px */}
			<ShapeBgMed className={cn('min-w-full hidden lg:block 2xl:hidden', shapeColor)} />

			<div
				className={cn(
					'flex justify-center w-full h-full',
					'lg:absolute lg:top-0 lg:left-0',
					// Note: for screen smaller than 1024px
					`${shapeBgColor} lg:bg-transparent`
				)}
			>
				<div className={cn('flex flex-col justify-center w-full h-full gap-2.5 max-w-eis-1440 ', 'py-8 px-6 lg:py-0 md:px-10 lg:px-14 xl:px-eis-72')}>
					<h1 className={cn(headingVariants({ type: 'h3' }), 'text-white', titleClassName)}>{title}</h1>

					{subtitle && <h2 className={cn(headingVariants({ type: 'h4' }), 'text-white', subtitleClassName)}>{subtitle}</h2>}
				</div>
			</div>
		</div>
	);
};

export default FormHeaderTitle;

FormHeaderTitle.propTypes = {
	variant: PropTypes.oneOf([
		'eis-shape-red',
		'eis-shape-orange',
		'eis-shape-dark-orange',
		'eis-shape-yellow',
		'eis-shape-light-green',
		'eis-shape-green',
		'eis-shape-light-blue',
		'eis-shape-blue',
		'eis-shape-dark-blue',
		'corporateBlue',
		'eis-shape-indigo',
		'eis-shape-light-purple',
		'eis-shape-purple',
		'eis-shape-light-pink',
		'eis-shape-pink',
	]).isRequired,
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string,
	className: PropTypes.string,
};

FormHeaderTitle.defaultProps = {
	variant: null,
	title: null,
	subtitle: null,
	className: null,
};
